import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ShopProvider from "./ShopProvider";

const mount = document.getElementById("przm-root");

const setShopifyDomain = (domain: string) => {
  if (!mount) {
    throw new Error("Expected mount point `#przm-root` to be present");
  }

  mount.dataset.shopifyDomain = domain;
};

const DomainLinks: { [d: string]: string[] } = {
  "rose-pamplemousse.myshopify.com": [
    "/6181978202/orders/d0314fbbb042ee4bc8bf3032d054c6dc"
  ],
};

const DomainSelector = ({ children }: { children: React.ReactElement }) => {
  const path = window.location.pathname;
  if (path === "/") {
    return (
      <div>
        <ul>
          {Object.keys(DomainLinks).map(shopTitle => (
            <li key={shopTitle}>
              {shopTitle}
              <ul>
                {DomainLinks[shopTitle].map(link => (
                  <li key={link}>
                    <a href={link}>{link}</a>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    );
  } else {
    const domain = Object.keys(DomainLinks).find(domain =>
      DomainLinks[domain].includes(path)
    );
    if (domain) {
      setShopifyDomain(domain);
    } else {
      throw new Error(
        "You are on an unsupported path for this app. Return to `/` and select a link."
      );
    }
    return children;
  }
};

if (process.env["NODE_ENV"] === "development") {
  ReactDOM.render(
    <DomainSelector>
      <ShopProvider component={App} />
    </DomainSelector>,
    mount
  );
} else {
  ReactDOM.render(<ShopProvider component={App} />, mount);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
